import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  paginationStyles: {
    backgroundColor: '#FFF',
  },
  activateCardButton: {
    backgroundColor: '#0A0',
    '&:hover': {
      backgroundColor:'#060',
    },
  },
  fetchingToolbar: {
    textAlign: 'center',
    width:     '100%',
  },
  alertContainer: {
    width:         '100%',
    minHeight:     0,
    maxHeight:     '2.5vh',
    paddingTop:    0,
    paddingBottom: 0,
    marginTop:     0,
    marginBottom:  0,
  },
  alertPaper: {
    padding: 0,
  },
}));

export default useStyles;
